export interface AboutContent {
  brandName: string;
  brandIntro: string;
  mission: string;
  vision: string;
  values: { title: string; description: string }[];
  stats: { value: string; label: string }[];
  team: { name: string; role: string; image: string }[];
  milestones: { year: string; title: string; description: string }[];
}

export const aboutContent: AboutContent = {
  brandName: "日本区域指南",
  brandIntro: "日本区域指南是国内领先的专业日本区域信息平台，致力于为中文读者提供最准确、最全面的日本一区二区相关资讯。自2020年创立以来，我们已服务超过百万读者，成为赴日旅行、留学、工作人士的首选信息门户。",
  mission: "以专业、客观的视角，帮助每一位读者深入了解日本各区域的核心特点，做出最适合自己的出行与生活决策。",
  vision: "成为全球华语圈最权威的日本区域知识平台，让每一位对日本感兴趣的读者都能在这里找到所需信息。",
  values: [
    { title: "专业严谨", description: "所有内容均经过资深日本研究者和当地居民双重审核，确保信息准确可靠。" },
    { title: "客观中立", description: "不偏袒任何区域，以数据和事实为基础，提供公平全面的对比分析。" },
    { title: "实用至上", description: "从读者实际需求出发，提供真正有用的出行、生活和工作参考信息。" },
    { title: "用户为本", description: "持续收集读者反馈，不断优化内容质量和阅读体验。" },
  ],
  stats: [
    { value: "500+", label: "专业文章" },
    { value: "100万+", label: "累计读者" },
    { value: "50+", label: "合作专家" },
    { value: "4.9", label: "读者评分" },
  ],
  team: [
    {
      name: "田中健一",
      role: "主编／日本区域研究专家",
      image: "https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20portrait%20in%20business%20attire%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20expression%2C%20corporate%20headshot%20photography&width=300&height=300&seq=team-tanaka&orientation=squarish",
    },
    {
      name: "李明月",
      role: "资深编辑／关东地区负责人",
      image: "https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20portrait%20in%20casual%20business%20attire%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20confident%20smile%2C%20corporate%20headshot%20photography&width=300&height=300&seq=team-li&orientation=squarish",
    },
    {
      name: "山本次郎",
      role: "资深编辑／关西地区负责人",
      image: "https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20portrait%20in%20smart%20casual%20attire%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20professional%20expression%2C%20corporate%20headshot&width=300&height=300&seq=team-yamamoto&orientation=squarish",
    },
    {
      name: "张雨萱",
      role: "内容策划／旅行达人",
      image: "https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20portrait%20in%20modern%20attire%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20bright%20friendly%20smile%2C%20corporate%20headshot%20photography&width=300&height=300&seq=team-zhang&orientation=squarish",
    },
  ],
  milestones: [
    { year: "2020", title: "平台创立", description: "由一群热爱日本文化的华人留学生共同创立，最初以个人博客形式发布区域相关内容。" },
    { year: "2021", title: "内容体系化", description: "建立了完整的日本一区、二区内容分类体系，月均读者突破10万人。" },
    { year: "2022", title: "团队扩展", description: "正式组建专业编辑团队，邀请多位日本区域研究专家加入编委会。" },
    { year: "2023", title: "百万读者", description: "累计读者突破100万，成为中文互联网最具影响力的日本区域信息平台之一。" },
    { year: "2024", title: "内容升级", description: "推出深度对比系列和视频内容，进一步丰富阅读体验。多篇文章获得行业奖项认可。" },
    { year: "2025", title: "国际化拓展", description: "启动多语言版本计划，扩大国际影响力，同时深化本地化优质内容。" },
  ],
};